/*
 * Menu Navi · comportamento della section header-v2
 * Porting della demo approvata del rework navigazione ISAIA (settembre 2026).
 *
 * <navi-mega-menu>   da 1280 px: pannelli a hover con "intento diagonale"
 *   - la prima apertura e' immediata; il cambio fra due voci aspetta
 *     data-switch-delay ms, cosi' attraversare una voce vicina non la apre
 *   - se il puntatore scende verso il pannello aperto (dy > |dx| * 0.4 su
 *     220 ms) le altre voci non rispondono: il pannello e' a tutta larghezza,
 *     quindi il triangolo di Amazon degenera e si guarda la direzione
 *   - uscendo dall'header il pannello si chiude dopo data-close-delay ms
 *   - su touch il primo tocco apre, il secondo segue il link
 *   Con data-intent="false" torna il comportamento di prima: cambio immediato.
 *
 * <navi-drawer-menu> sotto 1280 px: accordion esclusivi dentro il drawer del tema.
 *   Apertura, chiusura, blocco dello scroll e focus restano al tema (Drawer).
 *
 * Le immagini dei blocchi partono senza srcset e si accendono solo quando
 * servono (primo passaggio sul menu, o apertura di una voce nel drawer).
 */
(function () {
  'use strict';

  var DESKTOP = window.matchMedia('(min-width: 1280px)');
  var samples = [];
  var lastPointer = 'mouse';

  document.addEventListener('pointermove', function (event) {
    if (event.pointerType !== 'mouse') return;
    lastPointer = 'mouse';
    samples.push({ x: event.clientX, y: event.clientY, t: event.timeStamp });
    if (samples.length > 6) samples.shift();
  }, { passive: true });

  document.addEventListener('pointerdown', function (event) {
    lastPointer = event.pointerType || 'mouse';
  }, { passive: true, capture: true });

  function onBreakpointChange(handler) {
    if (DESKTOP.addEventListener) DESKTOP.addEventListener('change', handler);
    else DESKTOP.addListener(handler);
  }

  function offBreakpointChange(handler) {
    if (DESKTOP.removeEventListener) DESKTOP.removeEventListener('change', handler);
    else DESKTOP.removeListener(handler);
  }

  // Accende le immagini rimandate: prima le <source>, poi le <img>
  function hydrate(root) {
    root.querySelectorAll('[data-navi-srcset]').forEach(function (el) {
      el.setAttribute('srcset', el.getAttribute('data-navi-srcset'));
      el.removeAttribute('data-navi-srcset');
      if (el.hasAttribute('data-navi-src')) {
        el.setAttribute('src', el.getAttribute('data-navi-src'));
        el.removeAttribute('data-navi-src');
      }
    });
  }

  /* ========================== MEGA MENU DESKTOP ========================== */
  class NaviMegaMenu extends HTMLElement {
    connectedCallback() {
      this.wrapper = this.closest('[data-header-wrapper]');
      this.header = this.closest('.theme__header') || this.wrapper || this;
      this.items = Array.prototype.slice.call(this.querySelectorAll('[data-navi-item]'));

      var switchDelay = parseInt(this.dataset.switchDelay, 10);
      var closeDelay = parseInt(this.dataset.closeDelay, 10);
      this.intent = this.dataset.intent !== 'false';
      this.switchDelay = this.intent ? (isNaN(switchDelay) ? 250 : switchDelay) : 0;
      this.closeDelay = isNaN(closeDelay) ? 220 : closeDelay;

      this.switchTimer = 0;
      this.closeTimer = 0;
      this.pendingItem = null;
      this.hoverItem = null;
      this.warmed = false;

      this.onHeaderEnter = () => clearTimeout(this.closeTimer);
      this.onHeaderLeave = () => this.scheduleClose();
      this.onKeydown = (event) => this.handleKeydown(event);
      this.onDocumentClick = (event) => {
        if (this.openItem() && !this.header.contains(event.target)) this.closeAll();
      };
      this.onBreakpoint = () => this.closeAll();
      this.onBlockSelect = (event) => this.handleBlockSelect(event);
      this.onBlockDeselect = (event) => {
        if (this.contains(event.target)) this.closeAll();
      };
      this.onWarm = () => this.warm();

      this.header.addEventListener('mouseenter', this.onHeaderEnter);
      this.header.addEventListener('mouseleave', this.onHeaderLeave);
      this.addEventListener('keydown', this.onKeydown);
      this.addEventListener('mouseover', this.onWarm);
      this.addEventListener('focusin', this.onWarm);
      document.addEventListener('click', this.onDocumentClick);
      document.addEventListener('shopify:block:select', this.onBlockSelect);
      document.addEventListener('shopify:block:deselect', this.onBlockDeselect);
      onBreakpointChange(this.onBreakpoint);

      this.items.forEach((item) => this.bindItem(item));
    }

    disconnectedCallback() {
      this.header.removeEventListener('mouseenter', this.onHeaderEnter);
      this.header.removeEventListener('mouseleave', this.onHeaderLeave);
      document.removeEventListener('click', this.onDocumentClick);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
      document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
      offBreakpointChange(this.onBreakpoint);
      clearTimeout(this.switchTimer);
      clearTimeout(this.closeTimer);
      if (this.wrapper && this.openItem()) this.wrapper.classList.remove('meganav--visible');
    }

    bindItem(item) {
      var top = item.querySelector('[data-navi-top]');
      var hasPanel = item.hasAttribute('data-navi-has-panel');

      item.addEventListener('mouseenter', () => {
        if (!this.usesHover()) return;
        this.hoverItem = item;
        clearTimeout(this.closeTimer);
        this.requestSwitch(item);
      });

      // se ci si ferma su una voce dopo averla attraversata, si riprova
      item.addEventListener('mousemove', () => {
        if (!this.usesHover() || item.classList.contains('is-open')) return;
        this.hoverItem = item;
        this.requestSwitch(item);
      });

      item.addEventListener('mouseleave', () => {
        if (this.hoverItem === item) this.hoverItem = null;
        if (this.pendingItem === item) this.cancelSwitch();
      });

      if (!top) return;

      top.addEventListener('focus', () => {
        if (!DESKTOP.matches) return;
        this.cancelSwitch();
        clearTimeout(this.closeTimer);
        if (hasPanel) this.open(item);
        else this.closeAll();
      });

      top.addEventListener('click', (event) => {
        if (!DESKTOP.matches || !hasPanel) return;
        var isOpen = item.classList.contains('is-open');

        // su touch non c'e' hover: il primo tocco apre, il secondo segue il link
        if (lastPointer !== 'mouse' && !isOpen) {
          event.preventDefault();
          this.warm();
          this.open(item);
          return;
        }

        // voce senza destinazione (#): governa solo il pannello. Col mouse l'hover
        // l'ha gia' aperto e il clic lo lascia aperto (chiuderlo farebbe sfarfallare:
        // il primo movimento lo riaprirebbe); da tastiera (Invio) o a tocco apre e chiude.
        if (top.getAttribute('href') === '#') {
          event.preventDefault();
          var fromMouse = event.detail > 0 && lastPointer === 'mouse';
          if (fromMouse || !isOpen) this.open(item);
          else this.closeAll();
        }
      });

      item.addEventListener('focusout', (event) => {
        if (!DESKTOP.matches) return;
        var next = event.relatedTarget;
        if (next && (item.contains(next) || this.contains(next))) return;
        if (item.classList.contains('is-open')) this.close(item);
      });
    }

    usesHover() {
      return DESKTOP.matches && lastPointer === 'mouse';
    }

    requestSwitch(item) {
      var current = this.openItem();
      var hasPanel = item.hasAttribute('data-navi-has-panel');

      if (current === item || (!hasPanel && !current)) {
        this.cancelSwitch();
        return;
      }
      if (this.pendingItem === item) return;
      this.cancelSwitch();

      var go = () => {
        this.pendingItem = null;
        if (hasPanel) this.open(item);
        else this.closeAll();
      };

      if (!this.intent) {
        go();
        return;
      }

      // in viaggio verso il pannello aperto: la voce attraversata non risponde,
      // si ricontrolla appena il puntatore rallenta o si ferma
      if (current && this.divingIntoPanel(current)) {
        this.pendingItem = item;
        this.switchTimer = setTimeout(() => {
          this.pendingItem = null;
          if (this.hoverItem === item) this.requestSwitch(item);
        }, 120);
        return;
      }

      // nessun ritardo alla prima apertura: si paga solo sul cambio
      if (current && this.switchDelay > 0) {
        this.pendingItem = item;
        this.switchTimer = setTimeout(go, this.switchDelay);
      } else {
        go();
      }
    }

    cancelSwitch() {
      clearTimeout(this.switchTimer);
      this.pendingItem = null;
    }

    divingIntoPanel(current) {
      if (samples.length < 2) return false;
      var first = samples[0];
      var last = samples[samples.length - 1];
      if (last.t - first.t > 220) return false;              // campioni troppo vecchi
      if (performance.now() - last.t > 100) return false;    // puntatore fermo
      var panel = current.querySelector('[data-navi-panel]');
      if (!panel) return false;
      if (last.y >= panel.getBoundingClientRect().top) return false; // gia' dentro
      var dx = last.x - first.x;
      var dy = last.y - first.y;
      if (dy <= 2) return false;                             // non sta scendendo
      return dy > Math.abs(dx) * 0.4;                        // piu' verticale che laterale
    }

    scheduleClose() {
      if (!DESKTOP.matches || !this.openItem()) return;
      this.cancelSwitch();
      clearTimeout(this.closeTimer);
      this.closeTimer = setTimeout(() => this.closeAll(), this.closeDelay);
    }

    handleKeydown(event) {
      if (event.key !== 'Escape' && event.key !== 'Esc') return;
      var current = this.openItem();
      if (!current) return;
      var hadFocus = current.contains(document.activeElement);
      this.closeAll();
      if (hadFocus) {
        var top = current.querySelector('[data-navi-top]');
        if (top) top.focus({ preventScroll: true });
        // il focus riapre la voce: la si richiude subito, resta solo il focus
        this.closeAll();
      }
    }

    handleBlockSelect(event) {
      if (!DESKTOP.matches) return;
      var item = event.target.closest ? event.target.closest('[data-navi-item]') : null;
      if (!item || !this.contains(item)) return;
      this.warm();
      this.open(item);
    }

    open(item) {
      this.cancelSwitch();
      clearTimeout(this.closeTimer);
      this.items.forEach((other) => {
        if (other !== item) this.setOpen(other, false);
      });
      this.setOpen(item, true);
      this.warm();
      // il tema toglie la trasparenza all'header quando un mega menu e' aperto
      if (this.wrapper) this.wrapper.classList.add('meganav--visible');
    }

    close(item) {
      this.setOpen(item, false);
      if (!this.openItem() && this.wrapper) this.wrapper.classList.remove('meganav--visible');
    }

    closeAll() {
      this.cancelSwitch();
      clearTimeout(this.closeTimer);
      this.items.forEach((item) => this.setOpen(item, false));
      if (this.wrapper) this.wrapper.classList.remove('meganav--visible');
    }

    setOpen(item, on) {
      item.classList.toggle('is-open', on);
      var top = item.querySelector('[data-navi-top][aria-expanded]');
      if (top) top.setAttribute('aria-expanded', on ? 'true' : 'false');
    }

    openItem() {
      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i].classList.contains('is-open')) return this.items[i];
      }
      return null;
    }

    warm() {
      if (this.warmed) return;
      this.warmed = true;
      hydrate(this);
    }
  }

  /* ========================== ACCORDION DEL DRAWER ========================== */
  class NaviDrawerMenu extends HTMLElement {
    connectedCallback() {
      this.accordions = Array.prototype.slice.call(this.querySelectorAll('[data-navi-acc]'));
      this.drawer = this.closest('[data-drawer]');

      this.onClick = (event) => this.handleClick(event);
      // il tema lancia theme:sliderule:close a drawer chiuso: si riparte da tutto chiuso
      this.onDrawerClosed = () => this.collapseAll();
      this.onBreakpoint = () => {
        if (!DESKTOP.matches) return;
        this.collapseAll();
        if (this.drawer && this.drawer.classList.contains('is-open')) {
          this.drawer.dispatchEvent(new CustomEvent('theme:drawer:close', { bubbles: true }));
        }
      };
      this.onBlockSelect = (event) => this.handleBlockSelect(event);

      this.addEventListener('click', this.onClick);
      document.addEventListener('theme:sliderule:close', this.onDrawerClosed);
      document.addEventListener('shopify:block:select', this.onBlockSelect);
      onBreakpointChange(this.onBreakpoint);
    }

    disconnectedCallback() {
      document.removeEventListener('theme:sliderule:close', this.onDrawerClosed);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
      offBreakpointChange(this.onBreakpoint);
    }

    handleClick(event) {
      var trigger = event.target.closest('[data-navi-acc-trigger]');
      if (trigger && this.contains(trigger)) {
        event.preventDefault();
        var accordion = trigger.closest('[data-navi-acc]');
        this.toggle(accordion, !accordion.classList.contains('is-open'));
        return;
      }

      var back = event.target.closest('[data-navi-back]');
      if (back && this.contains(back)) {
        event.preventDefault();
        var open = back.closest('[data-navi-acc]');
        this.collapseAll();
        var openTrigger = open ? open.querySelector('[data-navi-acc-trigger]') : null;
        if (openTrigger) openTrigger.focus({ preventScroll: true });
      }
    }

    handleBlockSelect(event) {
      if (DESKTOP.matches) return;
      var accordion = event.target.closest ? event.target.closest('[data-navi-acc]') : null;
      if (!accordion || !this.contains(accordion)) return;
      if (this.drawer && !this.drawer.classList.contains('is-open')) {
        this.drawer.dispatchEvent(new CustomEvent('theme:drawer:open', { bubbles: true }));
      }
      this.toggle(accordion, true);
    }

    toggle(accordion, on) {
      this.accordions.forEach((other) => {
        if (other !== accordion) this.setOpen(other, false);
      });
      this.setOpen(accordion, on);
      if (on) hydrate(accordion);
    }

    setOpen(accordion, on) {
      accordion.classList.toggle('is-open', on);
      var trigger = accordion.querySelector('[data-navi-acc-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', on ? 'true' : 'false');
    }

    collapseAll() {
      this.accordions.forEach((accordion) => this.setOpen(accordion, false));
    }
  }

  if (!customElements.get('navi-mega-menu')) customElements.define('navi-mega-menu', NaviMegaMenu);
  if (!customElements.get('navi-drawer-menu')) customElements.define('navi-drawer-menu', NaviDrawerMenu);
})();
